// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  markerId: __t.u64().primaryKey().name("marker_id"),
  worldId: __t.u64().name("world_id"),
  refKind: __t.string().name("ref_kind"),
  refId: __t.u64().name("ref_id"),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
});
